<template>
  <TsSection append-class="bg-dewalt max-w-full" :data-testid="baseDataTestId + 'section'">
    <TsRow is-centered append-class="m-0">
      <TsIcon class="mt-4" name="game-icons:fist" size="32" :data-testid="baseDataTestId + 'icon'"/>
      <TsTypography append-class="pt-4 ml-1 text-nowrap" as="h1" :data-testid="baseDataTestId + 'brand-name'"><div v-html="props.brand" /></TsTypography>
    </TsRow>
  </TsSection>
</template>

<script setup lang="ts">
type Props = {
  brand: string;
}

const props = withDefaults(defineProps<Props>(), {
  brand: "DeWALT Guaranteed Tough"
});

const baseDataTestId = "brand-tag-";

</script>